import { PeriodProvider } from "@/providers/Period";
import { TbReportSearch } from "react-icons/tb";
import { lazy } from "react";

const RelatorioCote = lazy(() => import("./Corte"));
const RelatorioEndereco = lazy(() => import("./Endereco"));
const RelatorioEstoque = lazy(() => import("./Estoques"));
const RelatorioFotos = lazy(() => import("./Fotos"));
const RelatorioVolumes = lazy(() => import("./Volumes"));
const RelatorioVecimento = lazy(() => import("./Vencimento"));
const RelatorioDashboard = lazy(() => import("./Dashboard").then((m) => ({ default: m.RelatorioDashboard })));
const RelatorioAbastecimento = lazy(() => import("./Abastecimento"));
const MovimentacoesEmAberto = lazy(() => import("./MovimentacoesEmAberto"));
const PainelExpedicao = lazy(() => import("../Expedicoes/Relatorio"));
const RelatorioProdutividade = lazy(() => import("../Expedicoes/Relatorio"));

const RelatorioExtratoLote = lazy(() => import("./ExtratoLote"));
const RelatorioRastreioPalete = lazy(() => import("./RastreioPalete"));
const RelatorioEnderecoSeparacaoComparar = lazy(() => import("./EnderecoSeparacaoComparar"));
const RelatorioExpedicaoCompararVencimento = lazy(() => import("./ExpedicaoCompararVencimento"));
const RelatorioCurvaAbc = lazy(() => import("./CurvaAbc"));
const RelatorioLogExpedicao = lazy(() => import("./LogIntegracao/Expedicao"));
const RelatorioLogApontamento = lazy(() => import("./LogIntegracao/Apontamento"));
const RelatorioLogBloqueioEstoque = lazy(() => import("./LogIntegracao/BloqueioEstoque"));
const RelatorioLogRetornoDevolucao = lazy(() => import("./LogIntegracao/RetornoDevolucao"));
const RelatorioLogLiberacaoQuarentena = lazy(() => import("./LogIntegracao/LiberacaoQuarentena"));
const RelatorioLogTransferenciaDeposito = lazy(() => import("./LogIntegracao/TransferenciaDeposito"));
const RelatorioLogTransferenciaQuarentena = lazy(() => import("./LogIntegracao/TransferenciaQuarentena"));

const ModuleRelatorio = {
  menuItem: {
    to: "/relatorio",
    title: "Relatórios",
    icon: TbReportSearch,
    id: 11,
    childrens: [
      {
        to: "/relatorio/relatorio-de-estoque",
        title: "Estoque",
        fullTitle: "Relatórios de Estoques",
        id: 7,
      },
      {
        to: "/relatorio/relatorio-de-endereco",
        title: "Endereço",
        fullTitle: "Relatórios de Endereços",
        id: 8,
      },
      {
        to: "/relatorio/relatorio-de-produtividade-expedicao",
        title: "Produtividade",
        fullTitle: "Produtividade Expedição",
        id: 64,
      },
      {
        to: "/relatorio/relatorio-de-vencimentos",
        title: "Vencimento",
        fullTitle: "Relatório Vencimentos",
        id: 9,
      },
      {
        to: "/relatorio/relatorio-de-abastecimento",
        title: "Abastecimento",
        fullTitle: "Relatórios de Abastecimentos",
        id: 60,
      },
      {
        to: "/relatorio/relatorio-de-fotos",
        title: "Fotos",
        fullTitle: "Fotos",
        id: 83,
      },
      {
        to: "/relatorio/relatorio-de-corte",
        title: "Corte",
        fullTitle: "Relatórios de Corte",
        id: 60,
      },
      {
        to: "/relatorio/relatorio-de-volumes",
        title: "Volumes",
        fullTitle: "Relatórios de Volumes",
        id: 10,
      },
      {
        to: "/relatorio/relatorio-de-produtividade",
        title: "Produtividade",
        fullTitle: "Relatórios de Produtividade",
        id: 11,
      },
      {
        to: "/relatorio/relatorio-de-extrato-lote",
        title: "Extrato de Lotes",
        fullTitle: "Relatórios de Extrato de Lotes",
        id: 12,
      },
      {
        to: "/relatorio/relatorio-de-rastreio-de-palete",
        title: "Rastreio de Palete",
        fullTitle: "Relatório de Rastreio de Palete",
        id: 13,
      },
      {
        to: "/relatorio/log-apontamento",
        title: "Log Integração",
        fullTitle: "Log Integração",
        id: 14,
      },
      {
        to: "/relatorio/movimentos-em-aberto",
        title: "Movimentações em Aberto",
        fullTitle: "movimentacoes-em-aberto",
        id: 15,
      },
      {
        to: "/relatorio/expedicao-comparar-vencimento",
        title: "Comparar Vencimento",
        fullTitle: "Relatório de Comparação de Vencimentos (Expedição)",
        id: 16,
      },
      {
        to: "/relatorio/curva-abc",
        title: "Curva ABC",
        fullTitle: "Relatório Curva ABC de Expedição",
        id: 17,
      },
      {
        to: "/relatorio/relatorio-de-comparacao-de-enderecos",
        title: "Comparar Endereço",
        fullTitle: "Comparar Endereços de Separação",
        id: 18,
      },
    ],
  },

  routes: [
    {
      path: "/relatorio",
      element: <RelatorioDashboard />,
    },
    {
      path: "/relatorio/relatorio-de-estoque",
      element: <RelatorioEstoque />,
    },
    {
      path: "/relatorio/relatorio-de-endereco",
      element: <RelatorioEndereco />,
    },
    {
      path: "/relatorio/relatorio-de-vencimentos",
      element: (
        <PeriodProvider>
          <RelatorioVecimento />
        </PeriodProvider>
      ),
    },
    {
      path: "/relatorio/relatorio-de-produtividade-expedicao",
      element: (
        <PeriodProvider>
          <PainelExpedicao />
        </PeriodProvider>
      ),
    },
    {
      path: "/relatorio/relatorio-de-abastecimento",
      element: (
        <PeriodProvider>
          <RelatorioAbastecimento />
        </PeriodProvider>
      ),
    },
    {
      path: "/relatorio/relatorio-de-corte",
      element: (
        <PeriodProvider>
          <RelatorioCote />
        </PeriodProvider>
      ),
    },
    {
      path: "/relatorio/relatorio-de-fotos",
      element: (
        <PeriodProvider>
          <RelatorioFotos />
        </PeriodProvider>
      ),
    },
    {
      path: "/relatorio/relatorio-de-volumes",
      element: (
        <PeriodProvider>
          <RelatorioVolumes />
        </PeriodProvider>
      ),
    },
    {
      path: "/relatorio/relatorio-de-produtividade",
      element: (
        <PeriodProvider>
          <RelatorioProdutividade />
        </PeriodProvider>
      ),
    },
    {
      path: "/relatorio/relatorio-de-extrato-lote",
      element: (
        <PeriodProvider>
          <RelatorioExtratoLote />
        </PeriodProvider>
      ),
    },
    {
      path: "/relatorio/relatorio-de-rastreio-de-palete",
      element: (
        <PeriodProvider>
          <RelatorioRastreioPalete />
        </PeriodProvider>
      ),
    },
    {
      path: "/relatorio/log-apontamento",
      element: (
        <PeriodProvider>
          <RelatorioLogApontamento />
        </PeriodProvider>
      ),
    },
    {
      path: "/relatorio/log-bloqueio-estoque",
      element: (
        <PeriodProvider>
          <RelatorioLogBloqueioEstoque />
        </PeriodProvider>
      ),
    },
    {
      path: "/relatorio/log-expedicao",
      element: (
        <PeriodProvider>
          <RelatorioLogExpedicao />
        </PeriodProvider>
      ),
    },
    {
      path: "/relatorio/log-liberacao-quarentena",
      element: (
        <PeriodProvider>
          <RelatorioLogLiberacaoQuarentena />
        </PeriodProvider>
      ),
    },
    {
      path: "/relatorio/log-retorno-devolucao",
      element: (
        <PeriodProvider>
          <RelatorioLogRetornoDevolucao />
        </PeriodProvider>
      ),
    },
    {
      path: "/relatorio/log-transferencia-deposito",
      element: (
        <PeriodProvider>
          <RelatorioLogTransferenciaDeposito />
        </PeriodProvider>
      ),
    },
    {
      path: "/relatorio/log-transferencia-quarentena",
      element: (
        <PeriodProvider>
          <RelatorioLogTransferenciaQuarentena />
        </PeriodProvider>
      ),
    },
    {
      path: "/relatorio/movimentos-em-aberto",
      element: (
        <PeriodProvider>
          <MovimentacoesEmAberto />
        </PeriodProvider>
      ),
    },
    {
      path: "/relatorio/expedicao-comparar-vencimento",
      element: (
        <PeriodProvider>
          <RelatorioExpedicaoCompararVencimento />
        </PeriodProvider>
      ),
    },
    {
      path: "/relatorio/curva-abc",
      element: (
        <PeriodProvider>
          <RelatorioCurvaAbc />
        </PeriodProvider>
      ),
    },
    {
      path: "/relatorio/relatorio-de-comparacao-de-enderecos",
      element: (
        <PeriodProvider>
          <RelatorioEnderecoSeparacaoComparar />
        </PeriodProvider>
      ),
    },
  ],
};

export default ModuleRelatorio;
